import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	delete: {
		id: 'backlog.modals.sprint-delete-modal.delete',
		defaultMessage: 'Delete',
		description: '',
	},
	cancel: {
		id: 'backlog.modals.sprint-delete-modal.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
	title: {
		id: 'backlog.modals.sprint-delete-modal.title',
		defaultMessage: 'Delete sprint',
		description: '',
	},
	areYouSure: {
		id: 'backlog.modals.sprint-delete-modal.are-you-sure',
		defaultMessage: 'Are you sure you want to delete sprint {sprintName}?',
		description: '',
	},
});
